import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import JqueryLoad from '../../../JqueryLoad/JqueryLoad'
import "./Ratingstyle.css";
import "./RespondedTeacherList.css";
import Hdashboard from '../../../components/Hdashboard';
import { request_class_sponsored_teachers } from '../../../api/apiHandler';
import formatLocationAddress from '../../../utils/formatLocationAddress';
import { displayPrice } from '../../../utils/common.service';

import formatSpotsLeft from "../../../utils/formatSpotsLeft";
// Same card the learner sees on "sponsored_teachers", without the learner-only
// actions (follow, favourite, subscribe, share).
function ClassCard({ data }) {
    const navigate = useNavigate();
    const coupon = data?.class_coupon_data;
    const learnerOrdinal = (n) => n == 5 ? '5th or more' : n == 4 ? '4th' : n == 3 ? '3rd' : n == 2 ? '2nd' : '1st';

    return (
        <div className='Cust_single-box'>
            <div className="class_box mb-md-5 mb-4">
                {data?.teacher_message && data?.teacher_message !== "null" && data?.teacher_message !== "N/A" && (
                    <div className="teacher-response-msg mb-3 p-3 rounded-3" style={{ background: '#f8f4f9', borderLeft: '4px solid #570861' }}>
                        <div className="d-flex align-items-center mb-1">
                            <img src={data.teacher_profile_image} alt="teacher" className="rounded-circle me-2" style={{ width: '25px', height: '25px', objectFit: 'cover' }} />
                            <span className="fw-600 text-purple font-14">Teacher's Message:</span>
                        </div>
                        <p className="m-0 text-dif-black" style={{ fontStyle: 'italic', fontSize: '14px' }}>"{data.teacher_message}"</p>
                    </div>
                )}
                <div className="single-box d-xl-flex">
                    <div className="class_image_box h-100">
                        {coupon &&
                            <div className="ribbon-custom bg-diff-yellow text-dif-black">
                                {coupon.option_id == 1
                                    ? `Give a new learner discount (${coupon.amount_percentages}% OFF)`
                                    : coupon.option_id == 2
                                        ? `Subscribe ${coupon.subscribe == 5 ? '5 or more' : coupon.subscribe} learners to the class and get ${coupon.get_percentages}% off the ${learnerOrdinal(coupon.option2_learner)} learner/s.`
                                        : `Subscribe ${coupon.subscribe == 5 ? '5 or more' : coupon.subscribe == 8 ? '8 or more' : coupon.subscribe >= 10 ? '10 or more' : coupon.subscribe} learners and get ${coupon.option3_learner} learner${coupon.option3_learner > 1 ? 's' : ''} free`
                                }
                            </div>
                        }
                        <div className="class_img h-100 position-relative">
                            <div className="video-container">
                                <video loop width="100%" src={data?.video_file} controls />
                            </div>
                            {
                                data.spots === "New" ? (
                                    <div className="ribbon ">{formatSpotsLeft(data?.spots_left)}</div>
                                ) : parseInt(data.spots) <= 2 && parseInt(data?.spots) >= 1 ? (
                                    <div className="ribbon ribbon-orange">Only {formatSpotsLeft(data?.spots_left)}</div>
                                ) : data.spots === "Half" || parseInt(data.spots) > 2 ? (
                                    <div className="ribbon ribbon-pink">{formatSpotsLeft(data?.spots_left)}</div>
                                ) : null
                            }
                        </div>
                        <div>
                            <div className="d-sm-flex bottom-info position-static align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <img
                                        src={data.teacher_profile_image ? data?.teacher_profile_image : "./assets/images/NicePng_watsapp-icon-png_9332131.png"}
                                        alt="user1"
                                    />
                                    <div className="d-flex align-items-center">
                                        <span className="tech_nm ms-2">{data.teacher_name}</span>
                                        <img
                                            src={data.teacher_country}
                                            alt={`${data.teacher_country} flag`}
                                            style={{ width: '23px', height: '15px', objectFit: 'cover', marginRight: '8px' }}
                                            className="ms-2 det_flag_class"
                                        />
                                    </div>
                                </div>
                                <div className="star_rat">
                                    <span>
                                        <svg width={22} height={20} viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12.3787 0.703125C12.1716 0.273438 11.7341 0 11.2537 0C10.7732 0 10.3396 0.273438 10.1287 0.703125L7.61695 5.87109L2.00758 6.69922C1.53883 6.76953 1.1482 7.09766 1.00367 7.54688C0.859138 7.99609 0.976326 8.49219 1.31226 8.82422L5.38258 12.8516L4.42164 18.543C4.34351 19.0117 4.53883 19.4883 4.92554 19.7656C5.31226 20.043 5.82398 20.0781 6.24586 19.8555L11.2576 17.1797L16.2693 19.8555C16.6912 20.0781 17.2029 20.0469 17.5896 19.7656C17.9763 19.4844 18.1716 19.0117 18.0935 18.543L17.1287 12.8516L21.199 8.82422C21.5349 8.49219 21.656 7.99609 21.5076 7.54688C21.3591 7.09766 20.9724 6.76953 20.5037 6.69922L14.8904 5.87109L12.3787 0.703125Z"
                                                fill="#FDC840"
                                            />
                                        </svg>
                                    </span>&nbsp;
                                    <span className="fw-600">&nbsp;
                                        {data?.teacher_rating ? `${parseFloat(data?.teacher_rating).toFixed(1)}` : "0"}
                                        <span className="text-gray fw-500">({data?.teacher_review ? `${data?.teacher_review}` : "0"})</span>
                                    </span>
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-end follow-btn-sec position-static pb-3 w-100 ">
                                <span className="bg-yellow px-3 py-1 rounded-3 border-radius-10 text-capitalize">
                                    {data?.subcategory_value ? data?.subcategory_value : data?.main_category ? data?.main_category : "N/A"}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="class_room_info bg-transparent ps-lg-5">
                        <div className="class_room_inner justify-content-between">
                            <div className="class_rm_text ">
                                <div className="class_title d-block mb-4">
                                    <p className='fs-5 fw-bold'>{data?.title}</p>
                                </div>
                                <div className="d-md-flex mb-4 align-items-center">
                                    <div className="d-flex align-items-center">
                                        <span>
                                            <svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx={20} cy={20} r={20} fill="#570861" />
                                                <g clipPath="url(#clip0_2677_12814)">
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M16.6398 18.4492L15.1352 15.1914L13.6305 18.4492H16.6398ZM15.2758 14.0805C15.3555 14.1133 15.407 14.1742 15.4398 14.2445L18.5289 20.9336C18.6086 21.1023 18.5336 21.3086 18.3648 21.3836C18.1961 21.4633 17.9945 21.3883 17.9148 21.2195L16.9539 19.1289H13.3164L12.3508 21.2195C12.2711 21.3883 12.0742 21.4633 11.9008 21.3836C11.732 21.3039 11.657 21.1023 11.7367 20.9336L14.8258 14.2445C14.9055 14.0711 15.107 13.9961 15.2758 14.0805ZM17.9195 31.1523L21.8898 27.3555C21.9742 27.2805 22.0258 27.1727 22.0117 27.0508L20.568 15.4727L19.982 10.7898L19.8602 9.80547C19.7992 9.31328 19.5883 8.85859 19.2648 8.53047C18.9508 8.21641 18.5289 8.01953 18.0414 8.01953H10.0773C9.57578 8.01953 9.12109 8.22578 8.78828 8.55391C8.45547 8.88203 8.25391 9.34609 8.25391 9.84766V25.607C8.25391 26.1086 8.46016 26.568 8.78828 26.8961C9.12109 27.2289 9.57578 27.4305 10.0773 27.4305H16.2461V29.6195C16.2461 30.2664 16.5133 30.857 16.9398 31.2789C17.3664 31.7055 17.957 31.9727 18.6039 31.9727H29.3945C30.0414 31.9727 30.632 31.7055 31.0539 31.2789C31.4805 30.8523 31.7477 30.2617 31.7477 29.6195V14.3383C31.7477 13.6914 31.4852 13.1008 31.0539 12.6742C30.6273 12.2477 30.0367 11.9805 29.3945 11.9805H20.8164L20.9008 12.6602H29.3945C29.8539 12.6602 30.2758 12.8477 30.5758 13.1523C30.8805 13.457 31.068 13.8742 31.068 14.3383V29.6195C31.068 30.0789 30.8805 30.4961 30.5758 30.8008C30.2711 31.1055 29.8539 31.293 29.3945 31.293H18.5992C18.3602 31.2977 18.1258 31.2461 17.9195 31.1523ZM22.8977 19.9539C22.7102 19.9539 22.5602 19.8039 22.5602 19.6164C22.5602 19.4289 22.7102 19.2742 22.8977 19.2742H25.6492V18.6367C25.6492 18.4492 25.7992 18.2992 25.9867 18.2992C26.1742 18.2992 26.3289 18.4492 26.3289 18.6367V19.2742H29.0758C29.2633 19.2742 29.418 19.4289 29.418 19.6164C29.418 19.8039 29.2633 19.9539 29.0758 19.9539H27.932C27.9273 20.0008 27.9273 20.0477 27.9227 20.0945C27.9133 20.2445 27.8992 20.4039 27.8758 20.568C27.6977 21.9273 27.1539 23.1648 26.4039 24.0742C27.0086 24.6461 27.707 24.9836 28.4148 24.9836C28.6023 24.9836 28.7523 25.1383 28.7523 25.3258C28.7523 25.5133 28.5977 25.6633 28.4148 25.6633C27.5289 25.6633 26.6711 25.2555 25.9445 24.5664C25.218 25.2508 24.3602 25.6633 23.4742 25.6633C23.2867 25.6633 23.1367 25.5133 23.1367 25.3258C23.1367 25.1383 23.2867 24.9836 23.4742 24.9836C24.182 24.9836 24.8805 24.6461 25.4852 24.0695C24.843 23.2914 24.3508 22.2742 24.1117 21.1492C24.0695 20.9664 24.1914 20.7836 24.3742 20.7461C24.557 20.7086 24.7398 20.8258 24.7773 21.0086C24.9883 21.993 25.4055 22.8789 25.9492 23.5633C26.5914 22.7523 27.0555 21.6695 27.2102 20.4789C27.2289 20.3383 27.2383 20.1977 27.2523 20.0523C27.257 20.0195 27.257 19.9867 27.257 19.9492H22.8977V19.9539Z"
                                              fill="white"
                                            />
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_2677_12814">
                                              <rect width={24} height={24} fill="white" transform="translate(8 8)" />
                                            </clipPath>
                                          </defs>
                                            </svg>
                                        </span>
                                        <span className="fw-600 ms-2">{data.class_language}</span>
                                    </div>
                                </div>
                                <ul className="class_tag d-flex flex-wrap">
                                    <li className="px-3 py-2 rounded-3 bg-gray">
                                        <span className="text-gray45 fw-500 text-capitalize">Ages</span>
                                        <span className="fw-600 d-block">{data.min_age === 0 && data.max_age === 0 ? "Adults" : data.min_age === 0 ? `0-${data.max_age}` : data.max_age === 0 ? `${data.min_age}-Adults` : `${data.min_age}-${data.max_age}`}</span>
                                    </li>
                                    {data.length !== "offline course" && (
                                        <li className="px-3 py-2 rounded-3 bg-gray text-center">
                                            <span className="text-gray45 fw-500 text-capitalize">Class meets</span>
                                            {data.length == "Multi-Day" &&
                                                <span className="fw-600 d-block"> {data.session_per_week}/wk for {data.number_of_week} wks</span>
                                            }
                                            {(data.length == "Ongoing Weekly" || data.length == "Ongoing Monthly") &&
                                                <span className="fw-600 d-block">{data.session_per_week}/wk</span>
                                            }
                                            {data.length == "One-Time" &&
                                                <span className="fw-600 d-block">One-Time</span>
                                            }
                                        </li>
                                    )}
                                    <li className="px-3 py-2 rounded-3 bg-gray">
                                        <span className="text-gray45 fw-500 text-capitalize">Class Length</span>
                                        <span className="fw-600 d-block">{!data.length ? "N/A" : data.length == "offline course" ? "Offline Course" : data.length == "Multi-Day" ? "Multiday Course" : data.length}</span>
                                    </li>
                                    <li className="px-3 py-2 rounded-3 bg-gray">
                                        <span className="text-gray45 fw-500 text-capitalize">Class Duration</span>
                                        <span className="fw-600 d-block">{data.duration ? data.duration : "N/A"}</span>
                                    </li>
                                    <li className="px-3 py-2 rounded-3 bg-gray">
                                        <span className="text-gray45 fw-500 text-capitalize">Class size</span>
                                        <span className="fw-600 d-block text-capitalize">{data.class_size != "private" ? data.class_size : "1-on-1 Private Class"}</span>
                                    </li>
                                    {data.type === "In-Person" ? (
                                        <>
                                            <li className="px-3 py-2 rounded-3 bg-gray">
                                                <span className="text-gray45 fw-500 text-capitalize">Class Type</span>
                                                <span className="fw-600 d-block">
                                                    {data.type}
                                                    <img
                                                        src={data.teacher_country}
                                                        alt={`${data.teacher_country} flag`}
                                                        style={{ width: '23px', height: '15px', objectFit: 'cover', marginRight: '8px' }}
                                                        className="ms-2 det_flag_class"
                                                    />
                                                </span>
                                            </li>
                                            <li className="px-3 py-2 rounded-3 bg-gray">
                                                <span className="text-gray45 fw-500 text-capitalize">Class Location</span>
                                                <span className="fw-600 d-block">
                                                    {formatLocationAddress(data)}
                                                </span>
                                            </li>
                                        </>
                                    ) : (
                                        <li className="px-3 py-2 rounded-3 bg-gray">
                                            <span className="text-gray45 fw-500 text-capitalize">Class Type</span>
                                            <span className="fw-600 d-block">{data.type}</span>
                                        </li>
                                    )}
                                </ul>
                            </div>
                            <div className="payment-week rounded-3">
                                <div className="align-content-center align-items-center d-flex text-center flex-wrap h-100 justify-content-center pay_box px-4 py-2">
                                    <span className="payment_price fw-bold d-block w-100 text-center">{displayPrice(data?.price, data?.currency_code, data?.currency_symbol)}</span>
                                    <span className="d-block mb-1 w-100">{data.length === "Multi-Day" ? "Per course" : "Per class"} </span>
                                    {data.length === "Ongoing Weekly" && (
                                        <span className="d-block w-100">Weekly payment </span>
                                    )}
                                    {data.length === "Ongoing Monthly" && (
                                        <span className="d-block w-100">Monthly payment </span>
                                    )}
                                    {(data.length === "One-Time" || data.length === "Multi-Day" || data.length === "offline course") && (
                                        <span className="d-block w-100">One time payment</span>
                                    )}
                                    <div className="button w-100 mt-3">
                                        <button className="btn-theme btn-sm" onClick={() => navigate("/class_detail", { state: { class_id: data?.class_id } })}>View Class</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default function RespondedTeacherList({ isLoader }) {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const location = useLocation();

    const navigate = useNavigate();
    var request_class_id = location?.state && location.state.request_class_id

    const [sponsoredClasses, setSponsoredClasses] = useState([]);
    const [respondedClasses, setRespondedClasses] = useState([]);

    const SponsoredTeachers = () => {
        isLoader(true)
        request_class_sponsored_teachers({ request_class_id: request_class_id }).then((resposnse) => {
            isLoader(false)
            if (resposnse?.code == 1) {
                setSponsoredClasses(resposnse?.data?.sponsored_classes || [])
                setRespondedClasses(resposnse?.data?.responded_classes || [])
            } else {
                setSponsoredClasses([])
                setRespondedClasses([])
            }
        }).catch(() => isLoader(false));
    }

    useEffect(() => {
        SponsoredTeachers();
    }, []);

    return (
        <>
            <JqueryLoad />
            <Hdashboard />
            <main>
                <div className="dashboard-app d-lg-flex">
                    <header className="dashboard-toolbar d-lg-none d-flex justify-content-between">
                        <div className="align-items-center justify-content-between d-flex">
                            <div className="d-flex align-items-center">
                                <a href="#!" className="menu-toggle align-items-center d-lg-none d-flex">
                                    <i className="fa fa-bars" />
                                </a>
                                <a href="#" className="d-lg-none d-block brand-logo">
                                    <img src="./assets/images/logo.png" alt="logo" />
                                </a>
                            </div>
                        </div>
                    </header>
                    <div className="class-content">
                        <a onClick={() => navigate(-1)} className="mb-4 arrow_left mb-3 d-block">
                            <span>
                                <svg width={10} height={18} viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" />
                                </svg>
                                <span className="ms-2">Back</span>
                            </span>
                        </a>
                        <h2 className="mb-4 poppins fw-600">Sponsored Classes Matched Your Request</h2>
                        <div className="class_section mb-5">
                            {sponsoredClasses.length > 0 ? (
                                sponsoredClasses.map((item, index) => <ClassCard data={item} key={index} />)
                            ) : (
                                <div className="col-xl-8">
                                    <h4 className="d-flex justify-content-center mb-5 mt-5" style={{ color: "#570861" }}>No Matched Sponsored Classes Found</h4>
                                </div>
                            )}
                        </div>
                        <h2 className="mb-4 fw-600 poppins">Teacher Responses</h2>
                        <div className="class_section">
                            {respondedClasses.length > 0 ? (
                                respondedClasses.map((item, index) => <ClassCard data={item} key={index} />)
                            ) : (
                                <div className="col-xl-8">
                                    <h4 className="d-flex justify-content-center mb-5 mt-5" style={{ color: "#570861" }}>Teacher Not Responded Yet, Please Check Again Later</h4>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}
